export default "__VITE_ASSET__BQH5PXAW__"